/* tslint:disable */

export const homeTypes = {
  house: {
    imageDisable:
      "/assets/icon-png/home-type/house_inactive.png",
    imageEnable:
      "/assets/icon-png/home-type/house_active.png",
    image:
      "/assets/icon-svg/home-type-detached-outline-icon.svg",
    title: "บ้านเดี่ยว",
    filter_meta_slug: "house"
  },
  twinHouse: {
    imageDisable:
      "/assets/icon-png/home-type/twinhouse_inactive.png",
    imageEnable:
      "/assets/icon-png/home-type/twinhouse_active.png",
    image:
      "/assets/icon-svg/home-type-semi-detached-outline-icon.svg",
    title: "บ้านแฝด",
    filter_meta_slug: "twin_house"
  },
  townHouse: {
    imageDisable:
      "/assets/icon-png/home-type/townhouse_inactive.png",
    imageEnable:
      "/assets/icon-png/home-type/townhouse_active.png",
    image:
      "/assets/icon-svg/home-type-townhouse-outline-icon.svg",
    title: "ทาวน์เฮ้าส์",
    filter_meta_slug: "town_house"
  },
  shopHouse: {
    imageDisable:
      "/assets/icon-png/home-type/shophouse_inactive.png",
    imageEnable:
      "/assets/icon-png/home-type/shophouse_active.png",
    image:
      "/assets/icon-svg/home-type-shophouse-outline-icon.svg",
    title: "ตึกแถว",
    filter_meta_slug: "shop_house"
  },
  condo: {
    imageDisable:
      "/assets/icon-png/home-type/condo_inactive.png",
    imageEnable:
      "/assets/icon-png/home-type/condo_active.png",
    image:
      "/assets/icon-svg/home-type-condominium-outline-icon.svg",
    title: "คอนโด",
    filter_meta_slug: "condo"
  },
};

export const homeStructures = {
  concrete: {
    isAllowed: true,
    imageDisable:
      "/assets/icon-png/home-structure/concrete_disable.png",
    imageEnable:
      "/assets/icon-png/home-structure/concrete_inactive.png",
    imageSelected:
      "/assets/icon-png/home-structure/concrete_active.png",
    title: "ปูนทั้งหมด",
    remark: "*อิฐคอนกรีต มากกว่า 80% ของบ้าน",
  },
  concreteWood: {
    isAllowed: true,
    imageDisable:
    "/assets/icon-png/home-structure/woodconcrete_disable.png",
    imageEnable:
      "/assets/icon-png/home-structure/woodconcrete_inactive.png",
    imageSelected:
      "/assets/icon-png/home-structure/woodconcrete_active.png",
    title: "ปูนผสมไม้",
    remark: "*อิฐคอนกรีต มากกว่า 50% ของบ้าน",
  },
  // wood: {
  //   isAllowed: false,
  //   imageDisable:
  //   "/assets/icon-png/home-structure/wood_disable.png",
  //   imageEnable:
  //     "/assets/icon-png/home-structure/wood_inactive.png",
  //   imageSelected:
  //     "/assets/icon-png/home-structure/wood_active.png",
  //   title: "บ้านไม้ทั้งหมด",
  //   remark:
  //     "*ขออภัย ยังมีไม่แผนประกันรองรับบ้านที่มีโครงสร้างไม้ มากกว่า 50%",
  // },
};

export const homeUsageType = {
  residential: {
    title: "ใช้สำหรับที่อยู่อาศัย"
  },
  commercial: {
    title: "ใช้สำหรับเชิงพาณิชย์ เท่านั้น",
  },
  half_commercial: {
    title: "ใช้สำหรับที่อยู่อาศัย และเชิงพาณิชย์"
  },
}

export const riskIcons = [
  {
    imageUrl: "/assets/icon-png/risks/risk-thunder.png",
    title: "ฟ้าผ่า",
  },
  {
    imageUrl: "/assets/icon-png/risks/risk-waterleak.png",
    title: "น้ำรั่ว",
  },
  {
    imageUrl: "/assets/icon-png/risks/risk-shortcircuit.png",
    title: "เครื่องใช้ไฟฟ้าช๊อต",
  },
  {
    imageUrl: "/assets/icon-png/risks/risk-airplain.png",
    title: "เครื่องบินตกใส่บ้าน",
  },
];


export const smeReasons = [
  {
    title: "ความคุ้มครองต่อทรัพย์สินที่เอาประกันภัย",
    image: "/assets/icon-png/sme-property-coverage.png",
  },
  {
    title: "คุ้มครองความเสียหายจากไฟฟ้าลัดวงจร",
    image: "/assets/icon-png/sme-electricity-coverage.png",
  },
  {
    title: "คุ้มครองการสูญเสียหรือเสียหายต่อเงินที่จัดเก็บไว้ในสถานที่ประกอบการ",
    image: "/assets/icon-png/sme-money-coverage.png",
  },
  {
    title: "คุ้มครองความรับผิดต่อบุคคลภายนอก",
    image: "/assets/icon-png/sme-people-coverage.png",
  },
  {
    title: "คุ้มครองป้ายโฆษณา",
    image: "/assets/icon-png/sme-billboard-coverage.png",
  }]
export const paymentDetail = [
  {
    url: "/checkout/payment/credit-card/",
    icon: "/assets/icon-png/payment-1.png",
    label: "ชำระด้วยบัตร(เครดิต/เดบิต)",
  },
  // {
  //   url: '#',
  //   icon: "/assets/icon-png/payment-2.png",
  //   label: "ชำระ QR Code (พร้อมเพย์)"
  // },
];
export const faq = [
  {
    type: 'general',
    questions: [
      {
        question: 'ไม่ทราบพื้นที่ใช้สอยภายในตัวอาคาร (ในการ กรอกหรือให้ข้อมูลเพื่อสั่งซื้อ) ทำอย่างไร',
        answer: '<p>สามารถกรอกข้อมูล ชื่อ นามสกุล เบอร์โทร เพื่อให้เจ้าหน้าที่สามารถติดต่อกลับและช่วยเหลือ</p>',
      },
      {
        question: 'หากซื้อประกันบ้านเรียบร้อยแล้ว กรมธรรม์ สูญหาย ประกันจะยังคุ้มครองหรือไม่ ต้อง ทำอย่างไร',
        answer: '<p>กรมธรรม์ยังคงมีผลคุ้มครองปกติ ผู้เอาประกันภัยสามาถติดต่อขอสำเนากรมธรรม์กับทางบ.ทีคิวเอ็มฯ ได้</p>',
      },
      {
        question: 'ที่อยู่ในเอกสารกรมธรรม์ประกันบ้านผิด มีผลต่อความคุ้มครองหรือไม่',
        answer: '<p>มีผล เพราะการพิสูจน์สถานที่เกิดเหตุต้องอ้างอิง จากเลขที่ตั้งของสถานที่เอาประกันภัยนั้นๆ หากผู้ เอาประกันภัยพบว่าแจ้งผิด จะต้องรีบดำเนินการแจ้งให้ทาง บ.ทีคิวเอ็มฯ รับทราบเพื่อดำเนินการออกสลักหลังแก้ไขที่อยู่ให้ถูกต้องต่อไป</p>',
      },
    ]
  },
  {
    type: 'payment',
    questions: [
      {
        question: 'เอกสารกรมธรรม์ประกันบ้าน ซื้อแล้วเมื่อใดจะได้รับกรมธรรม์',
        answer: '<p>สำหรับลูกค้าที่ซื้อประกันบ้านผ่าน บ.ทีคิวเอ็มฯ รอเอกสารกรมธรรม์อิเล็กทรอนิกส์ (e-Policy) หลังจากที่ชำระเงิน 15 วันทำการ โดยจะมี SMS ส่งให้เพื่อดาวน์โหลดกรมธรรม์</p>',
      },
      {
        question: 'จ่ายเงินเรียบร้อยแล้ว ยังไม่ได้รับเอกสารกรมธรรม์ หากรอเกิน 15 วันแล้ว ต้องทำอย่างไร',
        answer: '<p>สามารถติดต่อช่องทาง Line <span>@tqmbroker</span> หรือโทร <span>1737</span> เพื่อแจ้งเรื่อง พร้อมแจ้งรายละเอียด ชื่อ-นามสกุล ของผู้เอาประกันภัย และ เอกสารยืนยันการชำระเงิน เช่น สลิป หลักฐานการตัดบัตร เป็นต้น เพื่อประสานงานตรวจสอบ</p>',
      },
      {
        question: 'หากซื้อประกันบ้านผ่านเว็บไซด์ ชำระเงินเรียบร้อยแล้ว ต้องการแก้ไขข้อมูลที่ผิดพลาดในกรมธรรม์สามารถทำได้หรือไม่ อย่างไร',
        answer: '<p>สามารถติดต่อช่องทาง <span>@tqmbroker</span> หรือโทร <span>1737</span> เพื่อให้เจ้าหน้าที่ช่วยแก้ไขต่อไป</p>',
      },
      {
        question: 'สั่งซื้อประกันภัยบ้าน ผิดแผนคุ้มครอง',
        answer: '<p>แบ่งเป็น 2 กรณี</p> <p>กรณีที่ 1 : ทำรายการสั่งแล้ว แต่ ยังไม่ได้ชำระเงิน สามารถเลือกทำรายการสั่งซื้อใหม่ได้</p> <p>กรณีที่ 2 : ทำรายการสั่งและชำระเงินแล้ว ผู้เอาประกันภัยสามารถกดซื้อแผนใหม่ได้อีกครั้งและชำระเงินตามปกติ ในส่วนที่ชำระเงินเข้ามาแล้ว รบกวนติดต่อเพื่อขอยกเลิกและคืนเงิน โดยโทรติดต่อ <span>1737</span></p>',
      },
      {
        question: 'การยกเลิกประกันภัยบ้าน สามารถทำได้หรือไม่',
        answer: '<p>สามารถทำได้ โดยทางบริษัทฯ จะคืนเบี้ยส่วนต่างที่ได้คุ้มครองตามเงื่อนไขของกรมธรรม์นั้นๆ</p>',
      },
      {
        question: 'การยกเลิกประกันภัยบ้าน สามารถทำได้หรือไม่',
        answer: '<p>หลังจากส่งเรื่องและเอกสารเพื่อยกเลิกเสร็จเรียบร้อยแล้ว จะใช้ระยะเวลา 15 วันทำการในการยกเลิก และอีก 15 วันทำการสำหรับประสานงานคืนเงิน</p>',
      },
      {
        question: 'ระยะเวลาการยกเลิก และ คืนเงินประกันภัยบ้าน',
        answer: '<p>มีผลนับจากวันที่ตกลงทำประกันภัยและได้ชำระเงินในระบบเรียบร้อยแล้ว โดยผู้ซื้อจะได้รับ SMS ยืนยันการสั่งซื้อ หรือ สามารถตรวจสอบยืนยันเพิ่มเติมได้ผ่านช่องทาง Line <span>@tqmbroker</span> หรือโทร <span>1737</span></p>',
      },
    ]
  },
  {
    type: 'claim',
    questions: [
      {
        question: 'ซ่อมแซมบ้านก่อนเคลมประกันบ้านได้ไหม',
        answer: '<p>สามารถซ่อมแซมบ้านได้ทันที เพียงแต่จะต้องถ่ายภาพความเสียหายและประเมินราคาค่าซ่อมไวก่อน เพื่อใช้ยื่นเคลมประกันบ้านในภายหลัง</p>',
      },
      {
        question: 'แจ้งเคลมประกันบ้านได้ตอนไหน',
        answer: '<p>สามารถแจ้งเคลมได้ตามความสะดวก แต่ไม่ควรเกิน 30 วันหลังจากบ้านได้รั บความเสียหาย</p>'
      },
      {
        question: 'เอกสารที่ใช้ในการเคลมประกันบ้าน มีอะไรบ้าง',
        answer: `<p>การเคลมประกันบ้าน มีหลายกรณี เช่น เคลมบ้านไฟไหม้ เคลมบ้านน้ำ้าท่วม แต่ไม่ว่าจะกรณีไหนๆ จะต้องใช้เอกสารเป็นหลักฐานในการยื่นเคลมกับทางบริษั ทประกันภัย ดังนี้</p> \
                 <ul>
                    <li>หนังสือเรียกร้องค่าสินไหมของผู้เอาประกันภัย</li>
                    <li>สำเนาบัตรประชาชน และสำเนาทะเบียนบ้านของผู้เอาประกันภัย พร้อมเซ็นสำเนาถูกต้อง</li>
                    <li>ภาพถ่ายความเสียหายทั้งหมด</li>
                    <li>ใบเสนอราคา/ใบเสร็จค่าซ่อมแซมจากช่าง</li>
                    <li>สำเนาบันทึกประจำวันของเจ้าหน้าที่ตำรวจ (กรณีที่ต้องมีการแจ้งความ)</li>
                    <li>หนังสือยอมรับผิดของบุคคลภายนอก (กรณีที่เสียหายจากการกระทำของบุคคลภายนอก)</li>
                 </ul>`
      },
      {
        question: 'ขั้นตอนการเคลมประกันบ้าน TQM Home ทําอย่างไร',
        answer: '<ol> \
                    <li>ดำเนินการแจ้งความเสียหาย แจ้งชื่อผู้เอาประกันภัยบ้าน ผ่านสายด่วน 1737 หรือทักแชท Facebook : TQM Insurance Broker ได้ตลอด 24 ชั่วโมง</li> \
                    <li>ยื่นเอกสารหลักฐานการเคลมประกันบ้าน เพื่อส่งเรื่องต่อไปยังบริษัทประกันทำการพิจารณาการเคลมและค่าสินไหม (บางบริษัทประกันอาจจะขอเข้าพื้นที่เกิดเหตุเพื่อประเมินความเสียหายอย่างละเอียด)</li> \
                    <li>แจ้งวันนัดรับค่าสินไหมชดเชย หลังผ่านขั้นตอนการพิจารณาเรียบร้อยแล้ว และรอรับค่าสินไหมผ่านบัญชีธนาคารเพียงเท่านี้ก็เป็นอันเสร็จสิ้น</li> \
                 </ol>'
      }
    ]
  },
]

export const stateTitleObj = [{
  state: 0,
  title: "คำนวณเบี้ย",
  className: "calculate"
},{
  state: 1,
  title: "เลือกแผน",
  className: "select"
},{
  state: 2,
  title: "ชำระเงิน",
  className: "payment"
}]


// หมวดที่ x => xxxxx
export const coverageTooltipDetailArr = [
  {
    description: 'คุ้มครองสิ่งปลูกสร้าง(ไม่รวมรากฐาน) และทรัพย์สินภายในสำหรับใช้ในการอยู่อาศัย',
  },
  {
    description: 'ทรัพย์สินที่คุ้มครอง จะเป็นทรัพย์สินที่ใช้ในการอยู่อาศัยในชีวิตประจำวัน ไม่รวมถึง เงิน ทอง อัยมณี ศิลปวัตถุ ของสะสม เป็นต้น',
  },
  {
    description: 'ชิงทรัพย์ หมายถึง การลักทรัพย์โดยใช้กำลังประทุษร้ายปล้นทรัพย์ หมายถึง การชิงทรัพย์แต่มีผู้ร่วมตั้งแต่ 2 คนขึ้นไปไม่คุ้มครอง สาเหตุจากการลักทรัพย์',
  },
  {
    description: 'ไม่คุ้มครองกรณีการเสียรูป หรือการแตกหักระหว่างขนส่ง ติดตั้ง หรือรื้อถอน',
  },
  {
    description: 'คุ้มครองเฉพาะบุคคลภายนอกหรือแขกเท่านั้น ไม่รวมถึง แม่บ้าน/ลูกจ้างที่ปฏิบัติงานเป็นประจำ ไม่คุ้มครองทรัพย์สินของผู้อื่นที่อยู่ภายใต้การดูแลของเจ้าของบ้าน',
  },
  {
    description: 'คุ้มครองกรณีเสียชีวิต จากเหตุไฟไหม้ ระเบิด เท่านั้น ** ขยายภัยอื่นๆ เช่น โจรกรรม เป็นต้น (เฉพาะบางแผนตามเงื่อนไขของบริษัทประกัน) **',
  }]

export const homePropertyAssets = [
  {
    value: 200000,
    option: "น้อยกว่า 200,000 บาท",
  },
  {
    value: 300000,
    option: "200,001 - 400,000 บาท",
  },
  {
    value: 500000,
    option: "400,001 - 600,000 บาท",
  },
  {
    value: 700000,
    option: "600,001 - 800,000 บาท",
  },
  {
    value: 900000,
    option: "800,001 - 1,000,000 บาท",
  },
  {
    value: 1500000,
    option: "1,000,001 - 2,000,000 บาท",
  },
  {
    value: 2500000,
    option: "2,000,001 - 3,000,000 บาท",
  },
  {
    value: 3500000,
    option: "3,000,001 - 4,000,000 บาท",
  },
  {
    value: 4000000,
    option: "มากกว่า 4,000,000 บาท",
  }
]

export const contactTimesArrList = [
  "ทุกวันเวลา 08.30 - 17.30 น.",
  "ทุกวันเวลา 17.31 - 19.59 น.",
  "ทุกวันเวลา 20.00 - 21.59 น.",
  "ทุกวันเวลา 22.00 - 23.59 น.",
  "ทุกวันเวลา 24.00 - 08.29 น.",
]

export const partners = [
  {
    id: 1,
    title: "Refinn",
    image: "/assets/images/partners/refinn-logo.png",
    target: "https://www.refinn.com/aff/tqm",
  },
  {
    id: 2,
    title: "Sansiri",
    image: "/assets/images/partners/sansiri.png",
    target: "#",
  },
  {
    id: 3,
    title: "AP",
    image: "/assets/images/partners/ap.png",
    target: "#",
  },
  {
    id: 4,
    title: "SC Asset",
    image: "/assets/images/partners/sc_assets.png",
    target: "#",
  },
  {
    id: 5,
    title: "Property perfect",
    image: "/assets/images/partners/property_perfect.png",
    target: "#",
  },
  {
    id: 6,
    title: "AP",
    image: "/assets/images/partners/ap.png",
    target: "#",
  },
]

export const eventCardItems = [
  {
    name: "WOW FESTIVAL 2022 (Wonder of Well-being City)",
    url: "/campaigns/wow-2022",
    date: "23 - 27 พ.ย. 2565",
    thumbnail: "/assets/images/wow2022campaign_cover_thumbnail.png",
    cover: {
      desktop: "/assets/images/wow2022campaign_cover_desktop.png",
      mobile: "/assets/images/wow2022campaign_cover_mobile.png"
    }
  },
]

export const actionText = {
  CLOSE: 'ปิด',
  CONFIRM: 'ตกลง',
  REFRESH: 'ลองใหม่อีกครั้ง',
}
